const Card = ({
    children,
    hasError,
    className = ''
}: {
    children: React.ReactNode
    hasError?: boolean
    className?: string
}) => {
    return (
        <div
            className={`rounded-2xl border bg-white p-5 dark:bg-white/[0.03] lg:p-6 ${
                hasError ? 'border-red-500' : 'border-gray-200 dark:border-gray-700'
            } ${className}`}
        >
            {children}
        </div>
    )
}

export default Card
